import { defineComponent, toRefs } from "vue";
import { useRouter } from "vue-router";
import { store } from "./store/PasswordChangeStore";
import { useLoad } from "./composition/Load";
import { Log } from "~/extensions/utils";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { commonStore } from "~/store/CommonStore";
import { PageID } from "~/extensions/utils/DefineTypes";
const log = Log.create("PasswordChangeComplete");
export default defineComponent({
    name: "PasswordChangeCompletePage",
    components: {
        BreadcrumbList
    },
    beforeRouteEnter(to, from, next) {
        if (from.name === "password-change" || !from.name) {
            next();
            return;
        }
        next(false);
    },
    async setup() {
        const { loadCompleteHtml, loading } = useLoad();
        const router = useRouter();
        // 画面名取得
        const pageName = commonStore.pageName(PageID.passwordChangeComplete);
        await loadCompleteHtml();
        const toListPage = () => {
            router.push({ name: "keiyaku" });
        };
        return {
            ...toRefs(store),
            ...useLoad(),
            loading,
            loadCompleteHtml,
            toListPage,
            pageName,
            PageID
        };
    }
});
